import React from 'react';

const chartTypes = ['spend', 'delivery'] as const; // TODO[mk] add 'margin' once we have values for it
export type ChartType = (typeof chartTypes)[number];

type ChartTypeSelectorProps = {
  selected: ChartType;
  setSelected: (type: ChartType) => void;
};

export function ChartTypeSelector({ selected, setSelected }: ChartTypeSelectorProps) {
  return (
    <GraphSelector
      label="View"
      options={chartTypes}
      setOption={setSelected}
      selectedOption={selected}
    />
  );
}

export type Granularity = 'day' | 'week' | 'month';
const granularityTypes = ['day', 'week', 'month'] as const;
type Props = {
  granularity: Granularity;
  setGranularity: (granularity: Granularity) => void;
};

export function GranularitySelector({ granularity, setGranularity }: Props) {
  return (
    <GraphSelector
      label="by"
      options={granularityTypes}
      setOption={setGranularity}
      selectedOption={granularity}
    />
  );
}

type GraphSelectorProps<T extends string> = {
  label: string;
  options: ReadonlyArray<T>;
  setOption: (option: T) => void;
  selectedOption: T;
};

function GraphSelector<T extends string>({
  label,
  options,
  setOption,
  selectedOption
}: GraphSelectorProps<T>) {
  return (
    <div className="relative mr-2 flex h-[28px] items-center">
      <div className="flex h-full items-center rounded-l border border-gray-300 bg-white px-3 py-1 text-sm text-gray-700">
        {label}
      </div>

      <div className="relative flex h-full items-center">
        <select
          id="options"
          className="focus:outline-hidden h-full appearance-none rounded-r border border-l-0 border-gray-300 bg-white py-0 pl-3 pr-8 text-sm font-medium capitalize focus:ring-0"
          onChange={event => setOption(options.find(item => item === event.target.value)!)}
          value={selectedOption}>
          {options.map(item => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
